import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  copyLinkFailure,
  copyLinkSuccess,
  downloadFileFailure,
  downloadFileSuccess,
  viewFolderFailure,
  viewFolderSuccess,
  viewVersionFailure,
  viewVersionSuccess,
} from "./actions";
import {
  VIEW_FOLDER,
  VIEW_VERSION,
  COPY_LINK,
  DOWNLOAD_FILE,
} from "./constants";
import { createBreadcrumbs } from "../../utils/helpers";
import { updateFolderBreadcrumb } from "../FolderAction/actions";

export function* viewFolderSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const companyId = yield select(
    (state) => state?.AuthReducer?.user?.company_id
  );
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/get-folder-content/${companyId}?${query}`
    );
    let crumbs = createBreadcrumbs(data?.path);
    yield put(updateFolderBreadcrumb(crumbs));
    yield put(viewFolderSuccess(data));
  } catch (e) {
    yield put(viewFolderFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching comment list!"));
  }
}

export function* viewVersionSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const companyId = yield select(
    (state) => state?.AuthReducer?.user?.company_id
  );
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/get-file-version-list/${companyId}?${query}`
    );
    yield put(viewVersionSuccess(data));
  } catch (e) {
    yield put(viewVersionFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching version history!"));
  }
}

export function* copyLinkSaga({ payload, onCopy }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const companyId = yield select(
    (state) => state?.AuthReducer?.user?.company_id
  );
  let query = QueryString.stringify({
    company_id: companyId,
    file_path: payload,
  });

  try {
    const { data } = yield call(api(token).post, `/api/copy-link?${query}`);
    yield put(copyLinkSuccess(data));
    typeof onCopy === "function" && onCopy(data);
    yield put(successAlert("Link has been copied!"));
  } catch (e) {
    yield put(copyLinkFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while copying file link!"));
  }
}

export function* downloadFileSaga({ payload, onDownload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const companyId = yield select(
    (state) => state?.AuthReducer?.user?.company_id
  );
  try {
    const data = yield call(
      api(token, null, false, true).post,
      `/api/download-file/${companyId}`,
      payload
    );
    if (data) {
      yield put(downloadFileSuccess(data));
      typeof onDownload === "function" && onDownload(data);

      if (payload?.downloadFile !== false) {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${payload.title}`);
        document.body.appendChild(link);
        link.click();
      }
    }
  } catch (e) {
    yield put(downloadFileFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while downloading file!"));
  }
}

export function* viewFolderFlow() {
  yield takeEvery(VIEW_FOLDER, viewFolderSaga);
}
export function* viewVersionFlow() {
  yield takeEvery(VIEW_VERSION, viewVersionSaga);
}
export function* copyLinkFlow() {
  yield takeEvery(COPY_LINK, copyLinkSaga);
}
export function* downloadFileFlow() {
  yield takeEvery(DOWNLOAD_FILE, downloadFileSaga);
}

export default function* FolderContentSaga() {
  yield all([
    viewFolderFlow(),
    viewVersionFlow(),
    copyLinkFlow(),
    downloadFileFlow(),
  ]);
}
